<div class="user-item">
  <div class="user-item__column">
    <strong>{{ data.createdBy || "-" }}</strong>
  </div>
  <div class="user-item__column createdOn">
    <strong>{{ data.createdOn | date : "dd/MM/yyyy - HH:mm:ss" }}</strong>
  </div>
  <div class="user-item__column">
    <strong>{{ data.duration || "-"}}</strong>
  </div>
  <div class="user-item__column">
    <strong>{{ data.client.name || "-" }}</strong>
  </div>
  <div class="user-item__column">
    <strong>{{ data.cell || "-" }}</strong>
  </div>
  <div class="user-item__column">
    <strong>{{ data.subCell || "-" }}</strong>
  </div>
  <div class="user-item__column">
    <strong>{{ data.processedQty || "-" }}/{{ data.requestQty || "-" }}</strong>
  </div>
  <div class="user-item__column status">
    <strong
      [ngClass]="{
        green: data.status == 'Finalizada',
        blue: data.status == 'Em Andamento',
        grey: data.status == 'Em Fila',
        yellow: data.status == 'Inconsistência'
      }"
      >{{ data.status || "-" }}</strong
    >
  </div>
  <div class="user-item__column actions">
    <app-icon-button
      title="Histórico"
      icon="assets/icons/file-history-line.svg"
      (clickFunc)="openHistory()"
    >
    </app-icon-button>
  </div>
</div>
